import { useState } from 'react'
import { useForm } from 'react-hook-form'

import { logisticApi } from 'redux/services/logistic'
import { UpdateLogisticStatus } from 'redux/services/logistic/types'

import { AppButton } from 'components/AppButton'
import { AppModal } from 'components/AppModal'
import { TextField } from 'components/TextField'

import { LOGISTIC_STATUS_TEXT } from 'constants/logistic'
import { LogisticStatus } from 'models/logistic'

import styles from './UpdateStatus.module.scss'

const labels: Record<LogisticStatus, string> = {
  ...LOGISTIC_STATUS_TEXT,
  [LogisticStatus.waiting]: 'Отклонить',
  // [LogisticStatus.in_process]: 'На доставке',
  // [LogisticStatus.for_delivery]: 'Выдана на доставку',
  // [LogisticStatus.given]: 'Доставлен',
  // [LogisticStatus.denied]: 'Возврат карты',
  // [LogisticStatus.accepted]: 'Документ принят',
  // [LogisticStatus.no_accepted]: 'Документ не принят',
  // [LogisticStatus.transferred]: 'Передан в подразделение',
  // [LogisticStatus.repeat]: 'Повторная доставка',
}

interface Props {
  id: number
  status: LogisticStatus
}
export function UpdateStatus({ id, status }: Props) {
  const [open, setOpen] = useState(false)
  const updateSatusForm = useForm<UpdateLogisticStatus>({
    defaultValues: {
      id,
      body: {
        status,
      },
    },
  })
  const [updateSatus, updateSatusState] =
    logisticApi.useUpdateLogisticStatusMutation()

  function onSubmitUpdateStatus(values: UpdateLogisticStatus) {
    updateSatus(values)
      .unwrap()
      .then(() => {
        setOpen(false)
      })
  }

  return (
    <>
      <AppButton variant="red" onClick={() => setOpen(true)}>
        {labels[status]}
      </AppButton>
      {open && (
        <AppModal onClose={() => setOpen(false)} title={`Сменить статус`}>
          <form
            className={styles.container}
            onSubmit={updateSatusForm.handleSubmit(onSubmitUpdateStatus)}
          >
            <TextField value={LOGISTIC_STATUS_TEXT[status]} disabled />

            <br />

            <TextField
              {...updateSatusForm.register('body.comment', {
                required: 'Обязательное поле',
              })}
              label="Комментарий"
              withError
              error={updateSatusForm.formState.errors.body?.comment?.message}
            />

            <AppButton disabled={updateSatusState.isLoading} type="submit">
              Принять
            </AppButton>
          </form>
        </AppModal>
      )}
    </>
  )
}
